import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const RECYCLED_RUBBER_URL = "https://recycledrubber.com/";

export const trackClick = async (ctaId, href, section) => {
  try {
    await axios.post(`${API}/track/click`, {
      cta_id: ctaId,
      href,
      section: section || null,
      referrer: typeof document !== "undefined" ? document.referrer : null,
    });
  } catch (e) {
    // never block the click on a failed log
    console.warn("track failed", e?.message);
  }
};

export const openRubber = (ctaId, section, href = RECYCLED_RUBBER_URL) => {
  trackClick(ctaId, href, section);
  if (typeof window !== "undefined") {
    window.open(href, "_blank", "noopener,noreferrer");
  }
};
